/* eslint-disable max-lines */
/* eslint-disable no-magic-numbers */
import React, { useCallback, useEffect, useState } from 'react';
import css from './FooterInterlinks.scss';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withConfig } from 'HOCs/withConfig/withConfig';
import { buildURL } from 'Helpers/url';
import { getPopularLocationsByLimit } from 'Actions/locations';
import { categoryIdSelector } from 'Selectors/categories';
import { getCategoryTree } from 'Reducers/componentHelpers';
import { itemsMetadataSelector } from 'Selectors/items';
import { selectedLocationSelector } from 'Selectors/location';
import { getBrandFilter, getTags } from 'Selectors/filtersTanak';
import { categoryWiseFooterLinkText, MOTORCYCLES, BIKES, VEHICLES_CATEGORY_ID, ONE_CRORE, ONE_LAKH, TWENTY_ITEMS, LOCATION_TYPE, LOCATION_LIMIT, categoryWiseFooterLinkSeoText, locationSpecificTitle, sellLocationSpecificTitle, sellCategorySpecificTitle, categorySpecificFooterTitle, REFURBISHED_FILTER, sellLocationSpecificTitleEntryPoint, TYPE_FILTER } from '../../constants/footerInterLinkData';
import { getBrandDataByModelId, isAtCityLevelAndCategoryTreeSelected } from 'Helpers/seoFooter';
import { Link } from 'panamera-react-ui';
import { MAIN_CATEGORY } from 'Constants/categories';
import { getLocale } from 'Selectors/config';
import { locations } from 'Components/InlineWidget/constants';
import withTrack from 'HOCs/withTrack/withTrack';
import withSessionFeature from 'HOCs/withSessionFeature/withSessionFeature';
import { noop } from 'Helpers/function';
import { FILTERSV2_EVENTS, LISTINGS_RESULTS, SELL_PAGE } from 'Constants/tracking';
import { parseFiltersForTracking } from 'Helpers/filtersTanak';
import { FormattedMessage as Translation, injectIntl } from 'react-intl';

export const FooterInterlinks = ({
    itemsMetadata,
    categoryTreeSelected,
    category,
    selectedLocation,
    appliedFilters,
    getPopularLocationsData,
    topPopularCityData,
    marketConfig,
    locale,
    levelWiseLocation,
    brandFilters,
    getBrandDataByModelId,
    track,
    sessionFeatures,
    categoryID,
    popularBrands = [],
    handleNavigate = noop,
    mode = 'buy',
    trackOrigin
}) => {
    const sellPageFlag = mode === 'sell';
    const footerHead = categorySpecificFooterTitle[categoryID];
    const locationHeadTitle = sellPageFlag && footerHead ? `Nearby Cities to ${footerHead} : ` : 'Location : ';
    const [urlData, setUrlData] = useState([]);
    const [linksInitialized, setLinksInitialized] = useState(false);
    const sellPageEntryPointCategories = [MAIN_CATEGORY.MOBILE_PHONES, MAIN_CATEGORY.CARS];
    const pgGuestHouseFlag = (sessionFeatures || []).includes('olxin-7842');
    const pgGuestHouseCategory = category?.id === MAIN_CATEGORY.PG_AND_GUEST_HOUSES;

    let brandData = {};

    const replaceRegex = (text, keys) => {
        if (!text) {
            return text;
        }

        let result = text;

        Object.entries(keys).forEach(([key, value]) => {
            const pattern = new RegExp(`{${key}}`, 'g');

            result = result.replace(pattern, value || '');
        });
        return result;
    };

    const getCategoryTreeInfo = () => {
        const { L1, L2 } = categoryTreeSelected;
        const categoryId = L2 ? L2.id : L1.id;
        const categoryName = L2?.name ? L2.name : L1.name;

        return {
            categoryId,
            categoryName
        };
    };

    const isAtCityLevelAndCategoryTreeSelectedFlag = isAtCityLevelAndCategoryTreeSelected(categoryTreeSelected, selectedLocation);
    const isWorkModeFilterSelected = !!appliedFilters.find(f => f.filterId === 'work_mode');
    const isRefurbishedFilterSelected = !!appliedFilters.find(f => f.filterId === REFURBISHED_FILTER);
    const shouldShowTypeFilter = pgGuestHouseFlag && !!appliedFilters.find(f => f.filterId === TYPE_FILTER);

    const nearByLocations = locations[selectedLocation?.id] || [];
    let shouldShowWorkModeFilter = false;

    if (
        category?.id === MAIN_CATEGORY.JOBS || pgGuestHouseFlag && pgGuestHouseCategory
        && (
            selectedLocation?.type !== 'COUNTRY'
            || (isWorkModeFilterSelected || shouldShowTypeFilter)
        )
    ) {
        shouldShowWorkModeFilter = true;
    }

    const getCategoryWiseFooterLinkText = (categoryKey, filterType, payload) => {
        const categoryFooterText = payload[categoryKey];

        if (!categoryFooterText) {
            return payload.defaultText;
        }

        if (categoryFooterText[filterType]) {
            return categoryFooterText[filterType];
        }
        return categoryFooterText.defaultText;
    };

    const modifyFooterText = ({ categoryName, filterType, id }) => {
        const text = getCategoryWiseFooterLinkText(id, filterType, categoryWiseFooterLinkSeoText);
        const content = categoryWiseFooterLinkSeoText[id];

        categoryName = content?.categoryName || categoryName;

        return { categoryName, text };
    };

    const generateAllFilterLinkText = (cityName, filterType, filterData, filterName = undefined) => {
        const { L1, L2 } = categoryTreeSelected;
        const categoryId = L1.id === VEHICLES_CATEGORY_ID && L2 ? L2.id : L1.id;
        let categoryName = L2 ? L2.name : L1.name;
        const payload = sellPageFlag ? sellLocationSpecificTitle : categoryWiseFooterLinkText;
        const text = getCategoryWiseFooterLinkText(categoryId, filterType, payload);

        let filterItemValue;

        switch (filterType) {
            case 'year':
                filterItemValue = filterData.min;
                break;
            case 'model': {
                filterItemValue = filterData.includes('-')
                    ? filterData.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')
                    : filterData;
                const regex = new RegExp(`\\b${ categoryName.slice(0, -1) }s?\\b`, 'gi');

                brandData = getBrandDataByModelId?.(brandFilters || [], filterData, brandData);

                const modelName = (brandData?.name && filterName)
                    ? `${brandData?.name} ${filterName}`
                    : filterItemValue.replace(regex, '').trim();

                filterItemValue = modelName;
                break;
            }
            case 'mileage':
                filterItemValue = Math.ceil(filterData.max / 1000) * 1000;
                break;
            case 'price': {
                const maxValue = Math.ceil(filterData.max / 1000) * 1000;
                let lakhValue = (`${(maxValue / ONE_LAKH).toFixed(1) } Lakh`).replace('.0', '');
                let croreValue = (`${(maxValue / ONE_CRORE).toFixed(1) } Crore`).replace('.0', '');

                if ((maxValue / ONE_CRORE).toFixed(1) > 1) {
                    croreValue = (`${(maxValue / ONE_CRORE).toFixed(1) } Crores`).replace('.0', '');
                }
                else if ((maxValue / ONE_LAKH).toFixed(1) > 1) {
                    lakhValue = (`${(maxValue / ONE_LAKH).toFixed(1) } Lakhs`).replace('.0', '');
                }

                const formatNumber = num => (num / 100000 >= 100 ? croreValue : lakhValue).replace('.0', '');
                const thousandValue = `₹ ${locale ? maxValue.toLocaleString(locale) : maxValue}`;

                filterItemValue = maxValue >= 100000 ? formatNumber(maxValue) : thousandValue;
                break;
            }
            default:
                filterItemValue = filterData.max || filterData;
                break;
        }

        categoryName = categoryName === MOTORCYCLES ? BIKES : categoryName;
        if (categoryName === 'Other Jobs') {
            categoryName = 'Other';
        }
        if (categoryName === 'Bicycles') {
            categoryName = 'Cycles';
        }

        let modifiedPayload = {
            categoryName: null,
            filterItemValue: null,
            text: null
        };

        modifiedPayload = modifyFooterText({ categoryName, filterType, id: category?.id });

        if (category?.id === MAIN_CATEGORY.HOUSES_FOR_RENT) {
            if (filterType === 'bachelors' && /not\s+allowed/g.test(filterItemValue)) {
                modifiedPayload.filterItemValue = 'Couples & Family';
            }
            else if (filterType === 'bachelors' && /allowed/g.test(filterItemValue)) {
                modifiedPayload.filterItemValue = 'Bachelors';
            }
            else {
                modifiedPayload.filterItemValue = filterItemValue;
            }
        }

        return (modifiedPayload?.text || text || '')
            .replace(/{category}/g, modifiedPayload?.categoryName || categoryName)
            .replace(/{value}/g, modifiedPayload?.filterItemValue || filterItemValue)
            .replace(/{city}/g, cityName)
            .replace(/Jobs\s+Jobs/g, 'Jobs');
    };

    const generateSellPageFooterLink = (categoryId, filterName, filterType, payload) => {
        const { categoryName } = getCategoryTreeInfo();
        const text = getCategoryWiseFooterLinkText(categoryId, filterType, payload);

        const result = replaceRegex(text, {
            category: categoryName,
            city: filterName,
            brandName: filterName
        });

        return result;
    };

    const makeLocationUrls = () => {
        const data = sellPageFlag ? nearByLocations : topPopularCityData;

        return data.map((item, index) => {
            const locationUrl = buildURL({
                location: item,
                category,
                params: {
                    filter: {}
                },
                base: sellPageFlag ? 'sell' : '',
                sessionFeatures
            });
            const linkText = generateAllFilterLinkText(item.name, 'location', '');

            return (
                <React.Fragment key={ index }>
                    <Link
                        className={ css.footerInterLink }
                        to={ locationUrl }
                    >
                        {linkText}
                    </Link>
                    {index !== data.length - 1 && <span> | </span>}
                </React.Fragment>
            );
        });
    };

    const reorderCategories = (filters, order) => {
        const orderSet = new Set(order);
        const reorderedFilters = [];
        const remainingFilters = [];

        for (const filter of filters) {
            if (orderSet.has(filter.id)) {
                reorderedFilters.push(filter);
            }
            else {
                remainingFilters.push(filter);
            }
        }
        reorderedFilters.sort((a, b) => order.indexOf(a.id) - order.indexOf(b.id));

        return [...reorderedFilters, ...remainingFilters];
    };

    const filterAllModelsForMake = (modelData, make) => {
        if (!modelData || !modelData.values || !Array.isArray(modelData.values)) {
            return [];
        }
        return modelData.values.filter(item => item.id.startsWith(make));
    };

    const generateMissingYearRanges = yearData => {
        const newArray = [];
        let currentId = 1;

        for (const obj of yearData) {
            const minYear = obj.range.min;
            const maxYear = obj.range.max;
            const yearCount = obj.count;

            // Add the original object with id
            newArray.push({
                id: currentId++,
                name: `[${minYear} - ${maxYear}]`,
                range: { min: minYear, max: maxYear },
                count: yearCount
            });

            // Check if we need to add the overlapping range
            if (maxYear < yearData[yearData.length - 1].range.max) {
                newArray.push({
                    id: currentId++,
                    name: `[${maxYear} - ${maxYear + 1}]`,
                    range: { min: maxYear, max: maxYear + 1 },
                    count: 0
                });
            }
        }
        const lastTwentyObjects = newArray.slice(-TWENTY_ITEMS);

        return lastTwentyObjects;
    };

    const updateObjectInArray = (oldFilterData, objectId, key, newFilterData) => {
        return oldFilterData.map(obj => {
            if (obj.id === objectId) {
                return { ...obj, [key]: newFilterData };
            }
            return obj;
        });
    };

    const getTopFilterData = (data, excludeTopData) =>
        data
            .filter(v => v.count > 0)
            .sort((a, b) => b.count - a.count)
            .slice(excludeTopData, excludeTopData + TWENTY_ITEMS)
            .sort((a, b) => a.id - b.id);

    const getTopCountItems = categoryFilterData => {
        let data = getTopFilterData(categoryFilterData.values, 0);

        if (
            categoryFilterData?.id === 'price'
            && category?.id === MAIN_CATEGORY.MOTORCYCLES
        ) {
            data = [...(categoryFilterData?.popular_values_configuration?.values || []), ...(data || [])];
        }

        if ((sessionFeatures || [])?.includes('olxin-6349') && categoryFilterData?.id === 'model' && category?.id === MAIN_CATEGORY.CARS) {
            const skipTopCount = 7;

            data = getTopFilterData(categoryFilterData.values, skipTopCount);
        }

        return data;
    };

    const removeOtherData = itemData => {
        return itemData.filter(item =>
            !/other/i.test(item.name)
        );
    };

    function getInterlinksWithLocations({
        categoryId,
        categoryName,
        item,
        key,
        locations,
        name,
        params,
        text,
        type,
        value
    }) {
        const result = [];

        for (const loc of locations) {
            const links = buildURL({
                location: loc,
                category,
                params
            });
            const linkText = text.replace(/{category}/g, categoryName)
                .replace(/{value}/g, value || '')
                .replace(/{city}/g, loc?.name);

            // show filter title based on selected location and category
            const title = (locationSpecificTitle?.[categoryId]?.[selectedLocation?.type]?.[key] || name).replace(/{value}/g, value || '');

            const obj = {
                parentID: key,
                parentName: title,
                parentType: type,
                itemId: item?.id,
                itemName: item?.name,
                itemRange: item?.range ? item.range : '',
                range: !!item?.range,
                to: links,
                fullTextToShow: linkText || 'Links'
            };

            result.push(obj);
        }

        return result;
    }

    // Generate filter related links for the given locations.
    const getFilterLinkWithLocationData = (levelWiseLocation, filterData, item) => {
        const { key, id, value, name, type } = filterData;
        const { categoryId, categoryName } = getCategoryTreeInfo();
        let text = getCategoryWiseFooterLinkText(categoryId, key, categoryWiseFooterLinkText);
        const params = { filter: key && id ? { [key]: id } : {}};
        const result = [];
        const topCities = 20;
        const topLocalities = 10;
        const isCityLevelLocationSelected = selectedLocation?.type === 'CITY';
        const topNumberOfLocation = {
            STATE: topCities,
            CITY: topCities,
            NEIGHBOURHOOD: topLocalities
        };

        // get location data based on selected location
        const getNearByLocations = () => {
            if (isCityLevelLocationSelected) {
                if (nearByLocations?.length > 0) {
                    return nearByLocations;
                }

                return [];
            }

            return levelWiseLocation.filter(location => location.location_id !== selectedLocation?.id);
        };

        const locations = getNearByLocations() || [];
        const topNearByLocations = locations.slice(0, topNumberOfLocation[selectedLocation?.type] || topCities);
        const topOtherLocations = topPopularCityData.slice(0, topNumberOfLocation[selectedLocation?.type] || topCities);

        result.push(...getInterlinksWithLocations({
            categoryId,
            categoryName,
            item,
            key,
            locations: topNearByLocations,
            name,
            params,
            text,
            type,
            value
        }));

        if (isCityLevelLocationSelected && topOtherLocations.length) {
            text = getCategoryWiseFooterLinkText(categoryId, key, categoryWiseFooterLinkText);
            result.push(...getInterlinksWithLocations({
                categoryId,
                categoryName,
                item,
                key: `${key}_other`,
                locations: topOtherLocations,
                name,
                params,
                text,
                type,
                value
            }));
        }

        return result;
    };

    const makeDynamicLinks = categories => {
        const finalData = [];
        const excludedCategories = ['category', 'location', 'inspected', 'price_per_ft', 'price_per_yd'];
        let filterCategory = reorderCategories(categories.filters, ['make', 'model']);
        const yearData = categories.filters.filter(item => item.id === 'year');
        let filters = [];

        if ('L1' in categoryTreeSelected && !('L2' in categoryTreeSelected)) {
            excludedCategories.push('price');
        }

        if (yearData.length !== 0) {
            const yearRangeData = generateMissingYearRanges(yearData[0].values);

            filterCategory = updateObjectInArray(filterCategory, 'year', 'values', yearRangeData);
        }

        for (let i = 0; i < filterCategory.length; i++) {
            const categoryItem = filterCategory[i];

            if (categoryItem.id === 'make' || categoryItem.id === 'model') {
                categoryItem.values = removeOtherData(categoryItem.values);
            }

            if (appliedFilters && appliedFilters.length === 1 && appliedFilters[0].filterId === 'make' && categoryItem.id === 'model') {
                const makeId = appliedFilters[0].props.id;

                categoryItem.values = filterAllModelsForMake(categoryItem, makeId);
            }

            if (!excludedCategories.includes(categoryItem.id)) {
                const topCountItems = getTopCountItems(categoryItem);

                topCountItems.forEach(item => {
                    const value = (categoryItem.type === 'range-slider' || categoryItem.type === 'range-input') ? item.range : item.id;
                    const params = { filter: { [categoryItem.id]: value }};
                    const links = buildURL({
                        location: selectedLocation,
                        category,
                        params
                    });

                    let linkText;

                    if (
                        (category?.id === MAIN_CATEGORY.JOBS
                        && categoryItem?.id === 'work_mode' || (pgGuestHouseFlag && pgGuestHouseCategory
                        && categoryItem?.id === TYPE_FILTER))
                        && levelWiseLocation?.length > 0
                    ) {
                        const _filter = {
                            key: categoryItem?.id,
                            id: item?.id,
                            value: item?.name,
                            name: categoryItem?.description,
                            type: categoryItem?.type
                        };

                        filters = getFilterLinkWithLocationData(levelWiseLocation, _filter, item);
                    }
                    else if (categoryItem.id === 'model') {
                        linkText = generateAllFilterLinkText(selectedLocation.name, categoryItem.id, item.id, item?.name || undefined);
                    }
                    else {
                        linkText = item.range ? generateAllFilterLinkText(selectedLocation.name, categoryItem.id, item.range) : generateAllFilterLinkText(selectedLocation.name, categoryItem.id, item.name);
                    }

                    const obj = {
                        parentID: categoryItem.id,
                        parentName: categoryItem.id === 'make' ? 'Make' : categoryItem.description,
                        parentType: categoryItem.type,
                        itemId: item.id,
                        itemName: item.name,
                        itemRange: item.range ? item.range : '',
                        range: !!item.range,
                        to: links,
                        fullTextToShow: linkText || 'Links'
                    };

                    if (!(category?.id === MAIN_CATEGORY.JOBS && categoryItem.id === 'work_mode' || (pgGuestHouseFlag && pgGuestHouseCategory && categoryItem.id === TYPE_FILTER))) {
                        finalData.push(obj);
                    }
                });
            }
        }

        if (category?.id === MAIN_CATEGORY.JOBS || pgGuestHouseFlag && pgGuestHouseCategory) {
            setUrlData([...finalData, ...filters]);
        }
        else {
            setUrlData(finalData);
        }
    };

    const shouldHideFilter = filter => {
        const { hideFiltersForFooterInterlinks } = marketConfig.get('SEO') || {};
        const filters = hideFiltersForFooterInterlinks;

        return filter && ((filters[category?.id] || []).indexOf(filter) > -1);
    };

    function handleTrack(event) {
        const listItem = event.target.closest('[data-aut-id]')?.getAttribute('data-aut-id') || undefined;
        const filters = appliedFilters.reduce((acc, filter) => {
            acc[filter.filterId] = [filter.props.id];
            return acc;
        }, {});

        if (listItem && (listItem === 'work_mode' || isRefurbishedFilterSelected)) {
            track?.(FILTERSV2_EVENTS.LISTING_TAP_APPLY_FILTERS, {
                category_id: category?.id,
                filters: parseFiltersForTracking(filters)
            });

            track?.(LISTINGS_RESULTS, { filters: parseFiltersForTracking(filters) });
        }
    }

    function generateLinksForRefurbishedMobile() {
        if (selectedLocation?.type === 'NEIGHBOURHOOD') {
            return undefined;
        }

        const topBrands = 3;
        const topLocations = 20;
        const refurbishedFilter = appliedFilters.find(f => f.filterId === REFURBISHED_FILTER);
        const makeFilter = appliedFilters.find(f => f.filterId === 'make');
        const categoryBasedTemplate = locationSpecificTitle[category?.id] || {};
        const filterKeys = Object.keys(categoryBasedTemplate);
        const filters = itemsMetadata?.filters
            ?.filter(filter => filterKeys.indexOf(filter.id) > -1)
            ?.map(filter => ({
                ...filter,
                values: filter?.values.filter(f => f?.id !== makeFilter?.props?.id)
            }))
            ?.map(filter => ({
                id: filter.id,
                name: filter.description,
                data: filter?.id === REFURBISHED_FILTER
                    ? topPopularCityData?.filter(loc => loc?.id !== selectedLocation?.id)?.slice(0, topLocations)
                    : filter?.values?.filter(f => f?.count > 0).sort((a, b) => b.count - a.count).slice(0, topBrands)
            })) || [];
        const result = [];

        for (const filter of (filters || [])) {
            const content = categoryBasedTemplate?.[filter?.id]?.[selectedLocation?.type] || { heading: '', template: '' };
            const heading = content?.heading || '';
            const template = content?.template || '';

            const texts = filter?.data?.map(i => ({
                id: filter.id,
                key: i?.id,
                text: template?.replace(`{${filter?.id === REFURBISHED_FILTER ? 'location' : filter?.id}}`, i.name).replace('iPhone Mobiles', 'iPhone'),
                to: buildURL({
                    category,
                    location: filter?.id === REFURBISHED_FILTER ? i : selectedLocation,
                    params: {
                        filter: {
                            [refurbishedFilter?.filterId]: refurbishedFilter?.props?.id || refurbishedFilter?.name,
                            ...(filter?.id !== REFURBISHED_FILTER && { [filter?.id]: i?.value })
                        }
                    }
                })
            }));

            result.push({ key: filter?.id, heading, texts });
        }

        return (
            isRefurbishedFilterSelected
                ? result?.map(item => (
                    <div className={ css.footerInterLinkWrapper } key={ item.key }>
                        <span className={ css.footerInterLinkHeaders }>{ item.heading } : </span>

                        <span>
                            {item?.texts?.map(item => (
                                <Link
                                    key={ item.key }
                                    className={ css.footerInterLink }
                                    to={ item.to }
                                    { ...{ title: item.text, 'data-aut-id': item?.id } }
                                >
                                    {item.text}
                                </Link>
                            )).reduce((prev, curr) => [prev, ' | ', curr])}
                        </span>
                    </div>
                )) : undefined
        );
    }

    if (!linksInitialized && urlData.length < 1 && (isAtCityLevelAndCategoryTreeSelectedFlag || shouldShowWorkModeFilter) && itemsMetadata && itemsMetadata.filters) {
        makeDynamicLinks(itemsMetadata);
        setLinksInitialized(true);
    }

    useEffect(() => {
        if ((isAtCityLevelAndCategoryTreeSelectedFlag || shouldShowWorkModeFilter) && itemsMetadata && itemsMetadata.filters) {
            makeDynamicLinks(itemsMetadata);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [itemsMetadata]);

    useEffect(() => {
        if (!topPopularCityData) {
            getPopularLocationsData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const groupedItems = urlData.reduce((acc, item) => {
        if (!acc[item.parentName]) {
            acc[item.parentName] = [];
        }
        if (item.parentID === 'work_mode' && shouldShowWorkModeFilter) {
            acc[item.parentName].push(item);
        }
        else {
            acc[item.parentName].push(item);
        }
        return acc;
    }, {});

    const linkItem = (to, key, text, onClick = undefined, separator = true) => {
        function handleLinkClick(e) {
            onClick(e, key);
        }
        return (
            <React.Fragment>
                <Link
                    className={ css.footerInterLink }
                    data-aut-id={ `sell-page-${key}` }
                    key={ key }
                    title={ text }
                    to={ to }
                    // eslint-disable-next-line
                    onClick={ onClick ? handleLinkClick : undefined}
                >
                    { text }
                </Link>
                { separator && <span> | </span>}
            </React.Fragment>
        );
    };
    const makeSellPageEntryPointLinks = () => {
        const { L1, L2 } = categoryTreeSelected;
        const categoryId = L1.id === VEHICLES_CATEGORY_ID && L2 ? L2.id : L1.id;

        return nearByLocations.map((location, index) => {
            const text = generateSellPageFooterLink(categoryId, location.name, 'location', sellLocationSpecificTitleEntryPoint);
            const to = buildURL({ category, location, base: 'sell' });
            const separator = Boolean(index !== nearByLocations.length - 1);

            return linkItem(to, location?.id, text, undefined, separator);
        });
    };
    const handleSellPageLinkClick = (e, makeName) => {
        track(SELL_PAGE.sell_page_clicked, {
            category_id: categoryID,
            origin: trackOrigin,
            chosen_option: e.currentTarget?.textContent || ''
        });
        handleNavigate(e, makeName);
    };

    const makeSellPagePopularBrandLinks = () => {
        return popularBrands?.map((brand, index) => {
            let text = generateSellPageFooterLink(categoryID, brand.name, 'brand', sellCategorySpecificTitle);
            const to = '/post';
            const separator = Boolean(index !== popularBrands.length - 1);

            if (brand.key === 'iphone') {
                text = text.replace(/Mobile Phones/i, '').replace(/\s+/g, ' ').trim();
            }
            return linkItem(to, brand?.key, text, handleSellPageLinkClick, separator);
        });
    };
    let shouldShowLocationFilter = isAtCityLevelAndCategoryTreeSelectedFlag && appliedFilters.length <= 1 && topPopularCityData && mode !== 'sell';
    const sellPageLocationInterLink = isAtCityLevelAndCategoryTreeSelectedFlag && sellPageFlag && nearByLocations.length;

    if (isWorkModeFilterSelected && shouldShowLocationFilter && selectedLocation.type !== 'CITY') {
        shouldShowLocationFilter = false;
    }
    if (isRefurbishedFilterSelected && categoryID === MAIN_CATEGORY.MOBILE_PHONES && selectedLocation.type === 'CITY') {
        shouldShowLocationFilter = false;
    }

    const shouldShowSellPageEntryPointLink = mode !== 'sell' && sellPageEntryPointCategories.includes(categoryID) && selectedLocation.type === 'CITY' && nearByLocations.length;

    const handleSellTracking = useCallback(() => {
        track(SELL_PAGE.sell_page_shown, {
            category_id: categoryID,
            origin: trackOrigin
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (shouldShowSellPageEntryPointLink) {
            handleSellTracking();
        }
    }, [shouldShowSellPageEntryPointLink, handleSellTracking]);

    let shouldShowHeading = (
        shouldShowLocationFilter
            || (isAtCityLevelAndCategoryTreeSelectedFlag && appliedFilters.length <= 1)
            || shouldShowSellPageEntryPointLink
            || (sellPageFlag && popularBrands?.length && footerHead)
            || isRefurbishedFilterSelected
            || isWorkModeFilterSelected
    );

    if (!isWorkModeFilterSelected && shouldShowWorkModeFilter) {
        shouldShowHeading = true;
    }
    else if (isWorkModeFilterSelected && urlData.length === 0) {
        shouldShowHeading = false;
    }

    return (
        <div className={ css.footerInterlinkContainer }>
            {
                shouldShowHeading
                    && (
                        <p className={ css.heading }>
                            <Translation id="explore_more" />
                        </p>
                    )
            }
            {shouldShowLocationFilter && (
                <div className={ css.locationLinkWrapper }>
                    <span data-aut-id="locationHead" className={ css.footerInterLinkHeaders }>{locationHeadTitle}</span>
                    {makeLocationUrls()}
                </div>
            )}
            {sellPageLocationInterLink ? (
                <div className={ css.locationLinkWrapper }>
                    <span data-aut-id="locationHead" className={ css.footerInterLinkHeaders }>{locationHeadTitle}</span>
                    {makeLocationUrls()}
                </div>
            ) : null}
            {sellPageFlag ? null : <div onClick={ handleTrack }>
                {
                    (
                        shouldShowWorkModeFilter
                        || (
                            category?.id !== MAIN_CATEGORY.JOBS
                            && !isRefurbishedFilterSelected
                            && isAtCityLevelAndCategoryTreeSelectedFlag
                            && appliedFilters.length <= 1
                        )
                    )
                    && Object.keys(groupedItems).map(parentName => {
                        const filter = groupedItems[parentName]?.[0]?.parentID || undefined;

                        return shouldHideFilter(filter) ? undefined : (
                            <div key={ parentName } className={ css.footerInterLinkWrapper }>
                                <span className={ css.footerInterLinkHeaders }>{parentName} : </span>
                                <span>
                                    {groupedItems[parentName].map(item => (
                                        <Link
                                            key={ item.itemName }
                                            className={ css.footerInterLink }
                                            to={ item.to }
                                            { ...{ title: item.fullTextToShow, 'data-aut-id': item.parentID } }
                                        >
                                            {item.fullTextToShow}

                                        </Link>
                                    )).reduce((prev, curr) => [prev, ' | ', curr])}
                                </span>
                            </div>
                        );
                    })}
            </div> }
            {shouldShowSellPageEntryPointLink ? (
                <div className={ css.locationLinkWrapper }>
                    <span data-aut-id="sellPageHead" className={ css.footerInterLinkHeaders }>{`${footerHead} :`} </span>
                    {makeSellPageEntryPointLinks()}
                </div>
            ) : null}
            {sellPageFlag && popularBrands?.length && footerHead ? (
                <div className={ css.locationLinkWrapper }>
                    <span data-aut-id="sellPageHeadBrand" className={ css.footerInterLinkHeaders }>{`Choose your Brand to ${footerHead} :`} </span>
                    {makeSellPagePopularBrandLinks()}
                </div>
            ) : null }

            {sellPageFlag ? null : <div onClick={ handleTrack }>{generateLinksForRefurbishedMobile()}</div>}
        </div>
    );
};

FooterInterlinks.propTypes = {
    categoryID: PropTypes.string,
    itemsMetadata: PropTypes.shape({
        filters: PropTypes.array
    }),
    categoryTreeSelected: PropTypes.shape({
        L1: PropTypes.object,
        L2: PropTypes.object
    }),
    category: PropTypes.object,
    selectedLocation: PropTypes.object,
    appliedFilters: PropTypes.array,
    getPopularLocationsData: PropTypes.func,
    topPopularCityData: PropTypes.array,
    marketConfig: PropTypes.shape({
        get: PropTypes.func.isRequired
    }).isRequired,
    locale: PropTypes.string,
    levelWiseLocation: PropTypes.array,
    brandFilters: PropTypes.array,
    getBrandDataByModelId: PropTypes.func,
    handleNavigate: PropTypes.func,
    track: PropTypes.func,
    sessionFeatures: PropTypes.arrayOf(PropTypes.string),
    mode: PropTypes.string,
    popularBrands: PropTypes.array,
    trackOrigin: PropTypes.string
};

const swapKeysValues = obj =>
    Object.fromEntries(
        Object.entries(obj).map(([key, value]) => [value, key])
    );

// Get the next level location.
// e.g, if L1 Location is selected, then fetch its L2 Location list.
const getSecondLevelLocationData = (locationData, selectedLocation, locationMapping) => {
    const getLocation = (locData, selectedLoc) => {
        if (selectedLoc?.type === locData?.location_type || locData?.location_type === locationMapping?.[selectedLoc?.type]) {
            const data = locData?.children?.length === 0 ? [locData] : locData?.children;

            return locData ? data : [selectedLoc];
        }

        // if L3 location selected, then return L3 Locations only.
        // if L4 location selected, then return L4 Locations only.
        const isSelectedLocationNeighbourhood = ((locData?.location_type === 'ADMIN_LEVEL_3' && selectedLoc?.type === 'NEIGHBOURHOOD') || (locData?.location_type === 'ADMIN_LEVEL_1' && selectedLoc?.type === 'CITY')) && locData.children?.length > 0;

        if (isSelectedLocationNeighbourhood) {
            return locData.children;
        }

        if (!locData?.children?.length) {
            return [selectedLoc];
        }

        return getLocation(locData?.children?.[0], selectedLoc);
    };

    return locationData ? getLocation(locationData, selectedLocation) : [selectedLocation];
};

export const mapStateToProps = (state, ownProps) => {
    const categoryID = categoryIdSelector(state, ownProps.params);
    let itemsMetadata = itemsMetadataSelector(state);
    const appliedFilters = getTags(state, categoryID);
    let locationMapping = ownProps.marketConfig?.get('locationMapping');

    locationMapping = swapKeysValues(locationMapping);

    const brandFilters = getBrandFilter(state, categoryID);

    itemsMetadata = {
        ...itemsMetadata,
        filters: itemsMetadata?.filters?.map(filter => {
            if (filter?.id === 'first_owner') {
                filter.values = filter?.values.slice(0, 2) || [];
                return filter;
            }
            return filter;
        })
    };

    const selectedLocation = selectedLocationSelector(state);
    const firstLevelLocationData = itemsMetadata?.filters?.find(f => f.id === 'location')?.values?.[0];
    const levelWiseLocation = firstLevelLocationData ? getSecondLevelLocationData(firstLevelLocationData, selectedLocation, locationMapping) : [selectedLocation];

    return {
        categoryID,
        categoryTreeSelected: getCategoryTree(state.categories.elements, categoryID),
        itemsMetadata,
        levelWiseLocation,
        category: state.categories.elements[categoryID],
        selectedLocation: selectedLocationSelector(state),
        appliedFilters,
        topPopularCityData: state.locations.topPopularLocations?.data,
        locale: getLocale(state),
        brandFilters,
        getBrandDataByModelId,
        trackOrigin: state.track.origin
    };
};

export const mapDispatchToProps = dispatch => ({
    getPopularLocationsData: () => dispatch(getPopularLocationsByLimit(LOCATION_TYPE, LOCATION_LIMIT))
});

export default compose(
    withConfig('marketConfig'),
    withTrack,
    withSessionFeature,
    injectIntl,
    connect(mapStateToProps, mapDispatchToProps)
)(FooterInterlinks);
